








import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  name: 'i-open',

})
export default class IOpen extends Vue {

  @Prop({type: [String], default: '#494949'}) protected color!: string
  @Prop({type: [Boolean], default: true}) protected isEdit!: boolean

}

